import {
  ErrorTypes,
  OrdersErrors,
  OrderTypes,
} from "@shared/features/trades/common/types";
import { OrderStatus } from "@shared/types";
import {
  EditTargetOrZone,
  ValidationTargetData,
  ValidationTargetsData,
} from "@shared/features/signals/EditSignal/types";
import { getTargetPrice } from "@shared/features/signals/EditSignal/utils";
import { orderHasStatus } from "@shared/features/trades/common/utils";
import {
  validateOrdersPercentages,
  validateOrdersPrices,
} from "@shared/features/tradingTerminal/common/utils";
import {
  validateNumberOfOrders,
  getDefaultOrdersSectionErrors,
  addError,
} from "@shared/features/trades/common/validationUtils.ts";

export const validateRelativeRatios = (
  targetsData: ValidationTargetsData,
  errors: OrdersErrors
) => {
  const validateSectionRatios = (
    targets: ValidationTargetData[],
    orderType: OrderTypes,
    errors: OrdersErrors
  ) => {
    const firstValidTarget = targets[0];
    const isValid = targets.every(
      (target) => Boolean(target.percent) === Boolean(firstValidTarget?.percent)
    );
    if (!isValid)
      addError(errors[orderType], ErrorTypes.RATIO_MUST_BE_SPECIFIED);
  };

  Object.entries(targetsData).forEach(([orderType, targets]) =>
    validateSectionRatios(targets, orderType as OrderTypes, errors)
  );
};

export const validateEditSignalTargets = (
  targetData: ValidationTargetsData,
  isShort: boolean,
  isBreakout: boolean,
  currentPrice: number,
  minPrice: number,
  maxPrice: number
): OrdersErrors => {
  const errors = Object.entries(targetData).reduce(
    (acc, [orderType, ordersData]) => {
      acc[orderType as OrderTypes] = getDefaultOrdersSectionErrors(ordersData);
      return acc;
    },
    {} as OrdersErrors
  );

  validateOrdersPrices(
    targetData,
    errors,
    isShort,
    isBreakout,
    currentPrice,
    minPrice,
    maxPrice,
    true,
    true
  );
  validateNumberOfOrders(targetData[OrderTypes.ENTRY], errors, isBreakout);
  validateOrdersPercentages(targetData, errors, true);
  validateRelativeRatios(targetData, errors);

  return errors;
};

export const getTargetsBelowPrice = (
  entryTargets: EditTargetOrZone[],
  price: number,
  isShort?: boolean
) =>
  entryTargets.filter((target) => {
    const currentTargetPrice = getTargetPrice(target, isShort);
    const shouldNewPriceCancelTarget = isShort
      ? currentTargetPrice >= price
      : currentTargetPrice <= price;
    return (
      shouldNewPriceCancelTarget &&
      orderHasStatus(
        target,
        true,
        OrderStatus.PENDING,
        OrderStatus.PARTIALLY_FULFILLED
      )
    );
  });
